import { createFileRoute, redirect } from '@tanstack/react-router';
import { homeFor } from '../auth/gate';
import { HushedFrame } from '../screens/auth/HushedFrame';
import { SignInPage } from '../screens/auth/SignInPage';
import { signInSearch } from '../screens/auth/sign-in-search';

export const Route = createFileRoute('/sign-in')({
  validateSearch: signInSearch,
  beforeLoad: async ({ context, search }) => {
    const principal = await context.auth.ensureOrNone();
    // Already signed in: straight on to where the person was going (a Paige Scan connect link opened in a browser
    // that was signed in after all), else home.
    if (principal && search.next) throw redirect({ href: search.next });
    if (principal) throw redirect(homeFor(principal));
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { next, reset } = Route.useSearch();
  const notice = reset ? 'Your password is changed. Sign in with the new one.' : null;
  return <SignInPage next={next ?? '/'} notice={notice} Frame={HushedFrame} />;
}
